import React from "react";
import { useTranslation } from "react-i18next";
import { u2000FormatIntegerCount } from "../../../tools/U2000NumberFormat";

interface U2000CommonTableFooterProps {
  nbItem: number;
  label: string;
}

const U2000CommonTableFooter: React.FC<U2000CommonTableFooterProps> = ({ nbItem, label }) => {
  const { i18n } = useTranslation();
  const formattedCount = u2000FormatIntegerCount(nbItem, i18n.language);

  return (
    <div className="mt-1 flex justify-end text-sm text-gray-600">
      {formattedCount} {label}
    </div>
  );
};

export default U2000CommonTableFooter;
